module.exports = __webpack_public_path__ + "3609744f65e0eb7dfa5a1f44f67b27c5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/feedbacks/review-2.png
// module id = zzEX
// module chunks = 0